﻿import type {AccessToken, Tnt} from "./types";

import {useMateApi} from "./useMateApi";
import {Ref, unref} from "vue";

export const useChatApi = (tenantOid: number | Ref<number>, accessToken: AccessToken) => {

    const {jsonEndpoint} = useMateApi(accessToken, tenantOid);
    const api = jsonEndpoint("/api/chats");
    let createMessagePromise: Promise<Tnt.Chat.MessageDto>;

    const getLocations = () =>
        api.get<Tnt.Chat.LocationDto[]>({}, {url: "/locations"});

    const getOperators = () =>
        api.get<Tnt.Chat.OperatorDto[]>({deleteState: "Active", _take: 200}, {url: "/operators"});

    const getChats = () =>
        api.get<Tnt.Chat.ChatDto[]>({skip: undefined, take: undefined});

    const getMessages = (chatUid: string) =>
        api.get<Tnt.Chat.MessageDto[]>({chatUid, skip: undefined, take: undefined}, {url: "/messages"});

    const getMessageDetails = (messageUid: string) =>
        api.get<Tnt.Chat.MessageDetailDto[]>({messageUid}, {url: "/messages/details"})

    const createChat = (data: Tnt.Chat.ChatCreationDto) =>
        api.post<Tnt.Chat.ChatDto>(data).then(chat => ({chat, exists: api.status.value === 200}));

    const deleteChat = (chatUid: string) =>
        api.delete({chatUid});

    const createMessage = async (chatUid: string, data: Tnt.Chat.MessageCreationDto) => {
        await createMessagePromise;
        createMessagePromise = api.post<Tnt.Chat.MessageDto>(data, {chatUid}, {url: "/messages"});
        return createMessagePromise;
    };

    const chatSearch = (request: Tnt.Chat.ChatSearchRequestDto) =>
        api.post<Tnt.Chat.ChatSearchResponseDto>(request, {}, {url: "/search"});

    return {
        getLocations,
        getOperators,
        getChats,
        getMessages,
        getMessageDetails,

        createChat,
        deleteChat,
        createMessage,
        chatSearch
    }
}
